import { render, staticRenderFns } from "./Jewelry.vue?vue&type=template&id=4c93d9c2&scoped=true"
import script from "./Jewelry.vue?vue&type=script&lang=js"
export * from "./Jewelry.vue?vue&type=script&lang=js"
import style0 from "./Jewelry.vue?vue&type=style&index=0&id=4c93d9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c93d9c2",
  null
  
)

export default component.exports